export default __webpack_public_path__ + "static/media/iamsa.d86a76fc.png";